import axios from "axios";

export const formatTelefone = (value: string): string => {
  if (!value) return "--";
  switch (value.length) {
    case 10:
      return `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(
        6,
        10
      )}`;
    case 11:
      return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(
        7,
        11
      )}`;
    case 12:
      return `(${value.slice(0, 3)}) ${value.slice(3, 8)}-${value.slice(
        8,
        12
      )}`;
    default:
      return value;
  }
};
export const fTel = formatTelefone;

export const resetNumberString = (value: string): string => {
  if (!value) return "--";
  return value.replace(/[\s()/\\|.-]/g, "");
};
export const rNS = resetNumberString;

export const formatDate = (value: string | Date): string => {
  if (!value) return "--";
  let v_ = new Date();

  // eslint-disable-next-line no-unused-expressions
  typeof value === "string" ? (v_ = new Date(value)) : (v_ = value);

  const day = v_.getDate().toString().padStart(2, "0");
  const month = (v_.getMonth() + 1).toString().padStart(2, "0");
  const year = v_.getFullYear();

  return `${day}/${month}/${year}`;
};
export const fDate = formatDate;

export const formatEmptyString = (value: string): string => {
  if (!value) return "--";
  return value?.trim() === "" ? "--" : value;
};
export const fEmpty = formatEmptyString;

export const formatCpf = (value: string): string => {
  if (!value) return "--";
  return resetNumberString(value).replace(
    /(\d{3})(\d{3})(\d{3})(\d{2})/,
    "$1.$2.$3-$4"
  );
};
export const fCpf = formatCpf;

export const formatLettersOnly = (value: string): string => {
  if (!value) return "";
  return value?.replace(/[^a-zA-Z]/g, "");
};
export const fLO = formatLettersOnly;

export const formatFullName = (value: string): string => {
  if (!value) return "";
  return value.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");
};
export const fName = formatFullName;

export const formatNumbersOnly = (value: string): string => {
  if (!value) return "";
  return value.replace(/\D/g, "");
};
export const fNO = formatNumbersOnly;

export const TooltipThemes = {
  warning: {
    tooltip: {
      sx: {
        background: "#ED6C02",
        color: "white",
        fontSize: 14,
        padding: 1,
      },
    },
    arrow: { sx: { color: "#ED6C02" } },
  },
  error: {
    tooltip: {
      sx: {
        background: "#F43636",
        color: "white",
        fontSize: 14,
        padding: 1,
      },
    },
    arrow: { sx: { color: "#F43636" } },
  },
  success: {
    tooltip: {
      sx: {
        background: "#4CAF50",
        color: "white",
        fontSize: 14,
        padding: 1,
      },
    },
    arrow: { sx: { color: "#4CAF50" } },
  },
  gray: {
    tooltip: {
      sx: {
        background: "#424248",
        color: "white",
        fontSize: 14,
        padding: 1,
      },
    },
    arrow: { sx: { color: "#424248" } },
  },
  primary: {
    tooltip: {
      sx: {
        background: "#2D5BFF",
        color: "white",
        fontSize: 14,
        padding: 1,
      },
    },
    arrow: { sx: { color: "#2D5BFF" } },
  },
  primaryDisabled: {
    tooltip: {
      sx: {
        background: "#819DFF",
        color: "white",
        fontSize: 14,
        padding: 1,
      },
    },
    arrow: { sx: { color: "#819DFF" } },
  },
};

export const COLORS = {
  white: "#FFFFFF",
  black: "#000000",
  lightGray: "#F2F4F8",
  green: "#4CAF50",
  primary50: "#EAEFFF",
  primary100: "#D5DEFF",
  primary200: "#ABBDFF",
  primary300: "#819DFF",
  primary400: "#577CFF",
  primary500: "#2D5BFF",
  secondary50: "#E6FCF2",
  secondary100: "#CCF8E5",
  secondary200: "#9AF2CC",
  secondary300: "#67EBB2",
  secondary400: "#35E599",
  secondary500: "#02DE7F",
  gray50: "#ECECEC",
  gray100: "#D5D5D5",
  gray200: "#A3A3A6",
  gray300: "#646363",
  gray400: "#424248",
  gray500: "#424248",
  successLight: "#D4EDD3",
  success50: "#ECFDF3",
  success100: "rgb(204, 248, 229)",
  success200: "rgb(154, 242, 204)",
  success300: "rgb(103, 235, 178)",
  success400: "rgb(53, 229, 153)",
  success500: "rgb(2, 222, 127)",
  warning100: "#ED6C0233",
  warning200: "#ED6C0266",
  warning300: "#ED6C0299",
  warning400: "#ED6C02CC",
  warning500: "#ED6C02",
  info100: "#2196F333",
  info200: "#2196F366",
  info300: "#2196F399",
  info400: "#2196F3CC",
  info500: "#2196F3",
  errorLight: "#FFCFD3",
  error100: "#F4363633",
  error200: "#F4363666",
  error300: "#F4363699",
  error400: "#F43636CC",
  error500: "#F43636",
};

export interface FileUploadI {
  nome: string;
  base64: string;
  contentType: string;
}

export enum SexoBiologico {
  Masculino = 0,
  Feminino = 1,
}

export enum MetodoPagamento {
  "RPA" = 1,
  "CNPJ" = 2,
}

export const BooleanOptions = [
  { label: "Sim", value: true },
  { label: "Não", value: false },
];

export const MetodoPagamentoOptions = [
  { label: MetodoPagamento[1], value: MetodoPagamento.RPA },
  { label: MetodoPagamento[2], value: MetodoPagamento.CNPJ },
];

export const SexoBiologicoOptions = [
  { label: "Masculino", value: SexoBiologico.Masculino },
  { label: "Feminino", value: SexoBiologico.Feminino },
];

export const TipoCreciOptions = [
  { label: "Estagiário", value: "00000000-0000-0000-0000-000000000001" },
  { label: "Definitivo", value: "00000000-0000-0000-0000-000000000002" },
];

export const TipoCreciC = {
  ESTAGIARIO: "00000000-0000-0000-0000-000000000001",
  DEFINITIVO: "00000000-0000-0000-0000-000000000002",
};

export const quantidadeFilhosOptions = Array.from({ length: 10 }, (_, i) => ({
  label: (i + 1).toString(),
  value: i + 1,
}));

export const debounce = (
  func: (...args: any[]) => void,
  delay: number
): any => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const searchCep = async (cep: string): Promise<any> => {
  try {
    const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
    return response;
  } catch (error) {
    throw new Error();
  }
};
